import o from "./pill/IstPill.vapor.vue.mjs";
import n from "./icon/IstIcon.vue.mjs";
import r from "./tab/IstTab.vue.mjs";
import m from "./tab/IstTabs.vue.mjs";
import i from "./skeleton/IstSkeleton.vue.mjs";
import "./skeleton/IstSkeleton.vue2.mjs";
import e from "./button/IstButton.vue.mjs";
import s from "./input/IstInput.vue.mjs";
import I from "./textarea/IstTextarea.vue.mjs";
import c from "./label/IstLabel.vue.mjs";
import f from "./dropdown/IstDropdown.vue.mjs";
import a from "./main_navigation/IstMainNavigation.vue.mjs";
import d from "./main_content/IstMainContent.vue.mjs";
import l from "./main_header/IstMainHeader.vue.mjs";
import p from "./main_app/IstMainApp.vue.mjs";
import C from "./spinner/IstSpinner.vue.mjs";
import u from "./badge/IstBadge.vue.mjs";
import M from "./card/IstCard.vue.mjs";
import T from "./card/IstCardContent.vue.mjs";
import D from "./card/IstCardDescription.vue.mjs";
import b from "./card/IstCardFooter.vue.mjs";
import g from "./card/IstCardHeader.vue.mjs";
import L from "./card/IstCardTitle.vue.mjs";
import v from "./progress/IstProgress.vue.mjs";
import "./progress/IstProgress.vue2.mjs";
import B from "./list/IstList.vue.mjs";
import H from "./list/IstItem.vue.mjs";
import S from "./tooltip/index.mjs";
import _ from "../node_modules/v-wave/dist/es/index.mjs";
function x(t) {
  t.component("IstPill", o), t.component("IstButton", e), t.component("IstDropdown", f), t.component("IstIcon", n), t.component("IstMainNavigation", a), t.component("IstMainContent", d), t.component("IstMainHeader", l), t.component("IstMainApp", p), t.component("IstTab", r), t.component("IstTabs", m), t.component("IstCard", M), t.component("IstTextarea", I), t.component("IstSkeleton", i), t.component("IstSpinner", C), t.component("IstProgress", v), t.component("IstList", B), t.component("IstItem", H), t.component("IstInput", s), t.component("IstLabel", c), t.component("IstBadge", u), t.component("IstCardContent", T), t.component("IstCardDescription", D), t.component("IstCardFooter", b), t.component("IstCardHeader", g), t.component("IstCardTitle", L), S.install(t), t.use(_, {
    color: "#91D1DF",
    dissolveDuration: 0.2,
    finalOpacity: 0.9,
    easing: "ease-in",
    duration: 0.2,
    initialOpacity: 0.9,
    directive: "ripple"
  });
}
const mt = { install: x };
export {
  u as IstBadge,
  e as IstButton,
  M as IstCard,
  T as IstCardContent,
  D as IstCardDescription,
  b as IstCardFooter,
  g as IstCardHeader,
  L as IstCardTitle,
  n as IstIcon,
  s as IstInput,
  c as IstLabel,
  p as IstMainApp,
  d as IstMainContent,
  l as IstMainHeader,
  a as IstMainNavigation,
  o as IstPill,
  i as IstSkeleton,
  C as IstSpinner,
  r as IstTab,
  m as IstTabs,
  I as IstTextarea,
  mt as default
};
